import { createListenerMiddleware } from '@reduxjs/toolkit'

import { sendMediavineIdentity } from '@/utils/adUtil'
import { setAuthentication } from '@/utils/analyticsUtil'

import { userActions } from './slice'
import { userThunks } from './thunks'

export const userListener = createListenerMiddleware()

userListener.startListening({
  actionCreator: userActions.authLoading,
  effect: async (_, { cancelActiveListeners, dispatch, signal }) => {
    cancelActiveListeners()

    const firebaseAuthUtil = await import('@/utils/firebaseAuthUtil')
    if (signal.aborted) return

    const unsubscribe = firebaseAuthUtil.subscribeFirebaseAuth({
      onEmailChange: (email) => sendMediavineIdentity(email),
      onProfileChange: (profile) => dispatch(userActions.update(profile)),
      onSignIn: (profile) => dispatch(userActions.authSignIn(profile)),
      onSignOut: () => dispatch(userThunks.signOut()),
    })

    // Awaits if the signal is aborted before unsubscribing
    await new Promise<void>((resolve) => {
      if (signal.aborted) resolve()
      else signal.addEventListener('abort', () => resolve(), { once: true })
    })
    unsubscribe()
  },
})

userListener.startListening({
  actionCreator: userActions.authSignIn,
  effect: () => setAuthentication('authenticated'),
})

userListener.startListening({
  actionCreator: userActions.authSignOut,
  effect: () => setAuthentication('unauthenticated'),
})
